<mat-card class="p-4">
  <div class="mb-3 flex items-center justify-between">
    <h2 class="text-xl font-semibold">Recent imports</h2>
    <button mat-stroked-button type="button" (click)="refreshed.emit()" [disabled]="loading()">Refresh</button>
  </div>

  @if (loading() && imports().length === 0) {
    <div class="flex items-center gap-3 p-4">
      <mat-spinner diameter="24" />
      Loading imports...
    </div>
  } @else if (imports().length === 0) {
    <p class="p-4 text-sm">No imports found yet.</p>
  } @else {
    <div class="overflow-x-auto">
      <table class="min-w-full text-left text-sm">
        <thead>
          <tr class="border-b">
            <th class="px-3 py-2 font-medium">File</th>
            <th class="px-3 py-2 font-medium">Client</th>
            <th class="px-3 py-2 font-medium">Status</th>
            <th class="px-3 py-2 font-medium">Size</th>
            <th class="px-3 py-2 font-medium">Created</th>
            <th class="px-3 py-2 font-medium">Completed</th>
            <th class="px-3 py-2 font-medium">Error</th>
            <th class="px-3 py-2 font-medium text-center">Summary</th>
            <th class="px-3 py-2 font-medium text-right">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (item of imports(); track item.id) {
            <tr class="border-b">
              <td class="px-3 py-3 font-medium">{{ item.originalFileName }}</td>
              <td class="px-3 py-3">{{ item.client || '-' }}</td>
              <td class="px-3 py-3">
                <span class="inline-flex rounded-full border px-2.5 py-1 text-xs font-semibold" [class]="statusClass(item.status)">
                  {{ item.status }}
                </span>
              </td>
              <td class="px-3 py-3">{{ formatFileSize(item.fileSizeBytes) }}</td>
              <td class="px-3 py-3">{{ item.createdDate | date: 'medium' }}</td>
              <td class="px-3 py-3">{{ item.completedDate ? (item.completedDate | date: 'medium') : '-' }}</td>
              <td class="px-3 py-3 text-xs text-rose-700">
                @if (item.status.toLowerCase().includes('failed') || item.status.toLowerCase().includes('error')) {
                  <span>Errors available</span>
                } @else {
                  {{ item.errorMessage || '-' }}
                }
              </td>
              <td class="px-3 py-3 text-center">
                @if (canDownloadSummary(item)) {
                  <button
                    mat-icon-button
                    type="button"
                    [disabled]="isSummaryDownloading(item.id)"
                    (click)="downloadSummary(item)"
                    [attr.aria-label]="isSummaryDownloading(item.id) ? 'Downloading summary file' : 'Download summary file'"
                    [matTooltip]="isSummaryDownloading(item.id) ? 'Downloading...' : 'Download summary'"
                  >
                    <mat-icon>{{ isSummaryDownloading(item.id) ? 'hourglass_top' : 'summarize' }}</mat-icon>
                  </button>
                } @else {
                  <span>-</span>
                }
              </td>
              <td class="px-3 py-3">
                <div class="flex justify-end">
                  @if (item.status.toLowerCase().includes('failed') || item.status.toLowerCase().includes('error')) {
                    <button
                      mat-icon-button
                      type="button"
                      [disabled]="isErrorDownloading(item.id)"
                      (click)="downloadErrors(item)"
                      [attr.aria-label]="isErrorDownloading(item.id) ? 'Downloading errors file' : 'Download errors file'"
                      [matTooltip]="isErrorDownloading(item.id) ? 'Downloading...' : 'Download errors'"
                    >
                      <mat-icon>{{ isErrorDownloading(item.id) ? 'hourglass_top' : 'error_outline' }}</mat-icon>
                    </button>
                  }

                  <button
                    mat-icon-button
                    type="button"
                    [disabled]="isDownloading(item.id)"
                    (click)="download(item)"
                    [attr.aria-label]="isDownloading(item.id) ? 'Downloading original file' : 'Download original file'"
                    [matTooltip]="isDownloading(item.id) ? 'Downloading...' : 'Download original'"
                  >
                    <mat-icon>{{ isDownloading(item.id) ? 'hourglass_top' : 'download' }}</mat-icon>
                  </button>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="mt-3 flex items-center justify-between gap-3 text-sm">
      <p>Showing {{ imports().length }} of {{ totalCount() }} imports</p>
      <div class="flex items-center gap-2">
        <button mat-stroked-button type="button" (click)="previousPage()" [disabled]="!canGoToPreviousPage() || loading()">
          Previous
        </button>
        <span>Page {{ pageNumber() }} of {{ totalPages() || 1 }}</span>
        <button mat-stroked-button type="button" (click)="nextPage()" [disabled]="!canGoToNextPage() || loading()">
          Next
        </button>
      </div>
    </div>
  }
</mat-card>
